import ImageSection1 from './ImageSection1';

export default ImageSection1;